import React, { useState, useEffect } from "react";
import { useGlobal } from "../context/ContenedorGlobal";
import { useApiFetch } from "../utils/apiFetch";

function InputSelectTecPorCat({ idCategoria, idSeleccionado, setIdSeleccionado }) {
    const [tecnicos, setTecnicos] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const { logout } = useGlobal();
    const apiFetch = useApiFetch();

    useEffect(() => {
        if (!idCategoria) return;

        const fetchTecnicos = async () => {
            setLoading(true);
            setError("");
            try {
                const data = await apiFetch("consultar_tecnicos_por_categoria.php", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ id_categoria: idCategoria })
                }, logout);

                if (data.status === "ok") {
                    setTecnicos(data.tecnicos || []);
                } else {
                    setError(data.message || "Error al consultar técnicos.");
                    setTecnicos([]);
                }
            } catch (err) {
                setError("Error al conectar con el servidor.");
            } finally {
                setLoading(false);
            }
        };

        fetchTecnicos();
    }, [idCategoria]);

    // Separar titulares y apoyo
    const titulares = tecnicos.filter(t => t.rol === "Titular");
    const apoyos = tecnicos.filter(t => t.rol === "Apoyo");

    return (
        <div className="form-group">
            <label>Seleccione técnico</label>
            {loading && <p>Cargando técnicos...</p>}
            {error && <p className="error">{error}</p>}
            <select
                value={idSeleccionado || ""}
                onChange={(e) => setIdSeleccionado(e.target.value)}
            >
                <option value="" disabled>Seleccione un técnico</option>

                {titulares.length > 0 && (
                    <optgroup label="Titulares">
                        {titulares.map((tec) => (
                            <option key={tec.id_tecnico} value={tec.id_tecnico}>
                                {`${tec.a_paterno} ${tec.a_materno} ${tec.usuario}`}
                            </option>
                        ))}
                    </optgroup>
                )}

                {apoyos.length > 0 && (
                    <optgroup label="Apoyo">
                        {apoyos.map((tec) => (
                            <option key={tec.id_tecnico} value={tec.id_tecnico}>
                                {`${tec.a_paterno} ${tec.a_materno} ${tec.usuario}`}
                            </option>
                        ))}
                    </optgroup>
                )}
            </select>
        </div>
    );
}

export default InputSelectTecPorCat;